'use client';
import { isNumber, isArray, isString, isNan } from '@s7/utils';

var BASE_UNITS_SIZE = 16;
var createConverter = function(unit) {
    // TODO: обернуть в memoize и проверить перформанс
    return function(units) {
        if (!units) {
            return "0" + unit;
        }
        var parse = function(value) {
            if (isString(value)) {
                var replaced = value.replace("px", "");
                if (!isNan(replaced)) {
                    return "" + Number(replaced) / BASE_UNITS_SIZE + unit;
                }
            }
            return value;
        };
        if (isNumber(units)) {
            return "" + units / BASE_UNITS_SIZE + unit;
        }
        var unitsArray = isArray(units) ? units : units.split(" ");
        return unitsArray.map(parse).join(" ");
    };
};
/**
 * Преобразует строки, содержащие размеры в единицах `px`, `em`, `rem` к численному формату.
 * Сохраняет формат строки, если она неконвертируемая, например `10%`, `1vh` или `auto`.
 *
 * Возвращает численное значение в `px`
 *
 * @return PureSize
 * */ var unit = function(value) {
    if (isNumber(value)) {
        return value;
    }
    if (value.endsWith("rem")) {
        return Number(value.slice(0, -3)) * BASE_UNITS_SIZE;
    }
    if (value.endsWith("em")) {
        return Number(value.slice(0, -2)) * BASE_UNITS_SIZE;
    }
    if (value.endsWith("px")) {
        return Number(value.slice(0, -2));
    }
    return Number(value);
};
/**
 * Приводит численные единицы или строку в единицах `px` к строке в единицах `rem`.
 * Сохраняет формат строки, если она неконвертируемая, например `10em`, `10%`, `1vh` или `auto`.
 * */ var rem = createConverter("rem");
/**
 * Приводит численные единицы или строку в единицах `px` к строке в единицах `em`.
 * Сохраняет формат строки, если она неконвертируемая, например `10rem`, `10%`, `1vh` или `auto`.
 * */ var em = createConverter("em");

export { BASE_UNITS_SIZE, em, rem, unit };
